import script from "./MainSecond.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSecond.vue?vue&type=script&setup=true&lang=js"

import "./MainSecond.vue?vue&type=style&index=0&id=9c3ad80a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c3ad80a"]])

export default __exports__